import { newApi } from "../restdux/index";

export const contractAPI = newApi("contract", "/api/contract/");

export const reducer = contractAPI.reducer;

export function fetchContracts() {
  return contractAPI.actions.list();
}

export function fetchContract(id) {
  return contractAPI.actions.get({ id });
}

export function updateContract(data) {
  return contractAPI.actions.update(data);
}

export const clearContractError = contractAPI.actions.clearError;
